export const strings = {
  english: {
    dashboard: 'Dashboard',
    orders: 'Orders',
    subscriptions: 'Subscriptions',
    downloads: 'Downloads',
    details: 'Account details',
    products: 'My products',
    logout: 'Logout',
  },
  japan: {
    dashboard: 'ダッシュボード',
    orders: '注文',
    downloads: 'ダウンロード',
    details: 'アカウント詳細',
    products: '購入済みの商品',
    logout: 'ログアウト',
  },
};
